import React, { useEffect, useRef } from 'react';
import './Aircraft.css';
import Inventory from './Inventory';
import Copyright from './Copyright';
import { useTranslation } from "react-i18next";

function Aircraft() {
  const canvasRef = useRef(null);
   const { t } = useTranslation("aircraft"); 
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    const pointSpacing = 10;
    const points = [];

    // créer le quadrillage de points
    for (let y = 0; y < height; y += pointSpacing) {
      for (let x = 0; x < width; x += pointSpacing) {
        points.push({ x, y, radius: 2, opacity: 0.2 });
      }
    }

    // dessiner les points
    function draw() {
      ctx.clearRect(0, 0, width, height);
      points.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${p.opacity})`;
        ctx.fill();
      });
    }

    // animation : surbrillance selon scroll
    function animate() {
      const scrollY = window.scrollY;
      points.forEach(p => {
        // variation simple : plus haut dans la page, plus lumineux
        p.opacity = 0.2 + Math.min(scrollY / 800, 0.5);
      });
      draw();
      requestAnimationFrame(animate);
    }

    animate();

    // resize
    window.addEventListener('resize', () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    });

    return () => window.removeEventListener('resize', () => {});
  }, []);

  return (
    <>
    <div className="aircraft-container">
      <canvas ref={canvasRef} className="background-canvas"></canvas>

      <h2 className="section-title">{t("title")}</h2>
      <p className="section-subtitle">{t("title2")}</p>

      <div className="aircraft-grid">
        <div className="aircraft-card left">
          <img src='/Images/reacteur_avion.jpg' alt="Avion côté gauche" />
          <div className="overlay"><p>{t("legende_left")}</p></div>
        </div>
        <div className="aircraft-card main">
          <img src='/Images/helisse_jet.jpg' alt="Avion principal" />
          <div className="overlay"><p>{t("legende_center")}</p></div>
        </div>
        <div className="aircraft-card right">
          <img src='/Images/jet_front.jpg' alt="Avion côté droit" />
          <div className="overlay"><p>{t("legende_droite")}</p></div>
        </div>
      </div>
    </div>
    <div className="separator"></div>
    <Inventory />
    <Copyright />
    </>

  );
}

export default Aircraft;
